import { CommonModule, DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, ElementRef, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ActivatedRoute } from '@angular/router';
import { Router, RouterLink, RouterModule, RouterOutlet } from '@angular/router';
import { indicadorAlertaPermanencia } from '../../../modal/indicadorAlertaPermanencia';
import { StatusIndicadorAlerta } from '../../../utilidades/enum/status.indicador.alerta.enum';
import { posto_simple } from '../../../modal/posto_simple';
import { mensagem } from '../../../modal/mensagem';
import { DateTimeFormatPipe } from '../../../utilidades/date-time-format.pipe';
import { TimeFormatPipe } from '../../../utilidades/time-format.pipe';
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable'
import html2canvas from 'html2canvas';
import { FormControl, FormsModule } from '@angular/forms';
import * as ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { StatusCorIndicadorAlerta } from '../../../utilidades/enum/status.cor.indicardor.alerta.enum';
import $ from 'jquery'; // Import jQuery
import { MultipleSelectionSelectAllComponent } from '../../../utilidades/multiple-selection-select-all/multiple-selection-select-all.component';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { PostoService } from '../../../service/posto.service';
import { RegiaoService } from '../../../service/regiao.service';
import { logosBase64 } from '../../../utilidades/logosBase64'
import { Console } from 'console';
import { RelatorioService } from '../../../service/relatorio.service';
import { PostoPonto } from '../../../utilidades/interfaceRelatorioPontoAtendimento';
import { TDocumentDefinitions } from 'pdfmake/interfaces';
import FileSaver from 'file-saver';

@Component({
  selector: 'app-cidadao-espera-criti-roxo',
  standalone: true,
  imports: [
    MatSidenavModule,
    MatCardModule,
    FormsModule,
    MatMenuModule,
    CommonModule,
    RouterLink,
    RouterOutlet,
    RouterModule,
    MultipleSelectionSelectAllComponent,
    MatFormFieldModule, MatDatepickerModule
  ],
  templateUrl: './ponto-atendimento.component.html',
  styleUrl: './ponto-atendimento.component.scss',
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    TimeFormatPipe, DateTimeFormatPipe, provideNativeDateAdapter()]
})


export class PontoAtendimentoComponent implements OnInit {
  public SemDados: boolean = false;
  larguraTela: number = window.innerWidth;
  login: string | null | undefined = null;
  data: PostoPonto[] = [];
  dataMensagem = [];
  listaPostos: any = [];
  listaRegiao: any = [];
  RegiaoSelecionada: any;
  PostosSelecionados: any[] = [];
  usuario: any;
  feitaPesquisa: boolean = true;

  campoOrdenado: string = '';
  direcaoOrdenacao: 'asc' | 'desc' = 'asc';

  logosEsquerda: any[] = [];
  logosDireita: any[] = [];

  constructor(private route: ActivatedRoute, private router: Router, private _logosBase64: logosBase64,
    private relatorioService: RelatorioService, @Inject(DOCUMENT) private document: Document,
    private postoService: PostoService, private regiaoService: RegiaoService,
    public timeFormatPipe: TimeFormatPipe,
    public dateTimeFormatPipe: DateTimeFormatPipe) {
    try {
      const localStorage = document.defaultView?.localStorage;
      if (localStorage)
        this.login = localStorage.getItem('login');
      if (this.login == null || this.login == undefined)
        this.router.navigate(['/iniciar']);
    }
    catch (ex) {
      this.router.navigate(['/iniciar']);
    }
  }
  ngOnInit() {
    let login = localStorage.getItem('login');
    this.usuario = localStorage.getItem('salaSituacao');
    this.listarPostos();
    this.listarRegiao();

    this._logosBase64.carregarLogos();

        this._logosBase64.logosEsquerda$.subscribe(data => {
            this.logosEsquerda = data;
        });

        this._logosBase64.logosDireita$.subscribe(data => {
            this.logosDireita = data;
        });
  }
  processarInfo(info: any) {
    this.PostosSelecionados = info;
  }

  getTotalAtendimentos(ponto: any): number {
    return ponto.pontosAtendimentos.reduce((sum: number, pa: any) => sum + pa.atendimentos.length, 0);
  }

  listarPostos() {
    let sala: any = localStorage.getItem('salaSituacao');
    sala = JSON.parse(sala);
    this.postoService.getPostoUsuario(this.usuario).pipe().subscribe((result: any) => {
      result.Posto.forEach((posto: any) => {
        this.listaPostos.push(posto);
      });

      this.listaPostos.sort(function (a: any, b: any) {
        if (a.descricao > b.descricao) {
          return 1;
        }
        if (a.descricao < b.descricao) {
          return -1;
        }
        return 0;
      })
    })
  }
  listarRegiao() {
    this.regiaoService.getRegiaoUsuario(this.usuario).pipe().subscribe((element: any) => {
      console.log(element);
      element.Regiao.forEach((regiao: any) => {
        this.listaRegiao.push(regiao);
      });
      this.listaRegiao.sort(function (a: any, b: any) {
        if (a.descricao > b.descricao) {
          return 1;
        }
        if (a.descricao < b.descricao) {
          return -1;
        }
        return 0;
      })
    })
  }

  onSelecionar(valor: string) {
    this.RegiaoSelecionada = valor; // Atualiza o valor quando o select muda
  }


  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.larguraTela = window.innerWidth;
  }

  Pesquisa() {
    if (this.PostosSelecionados.length != 0) {
      this.feitaPesquisa = false;

      console.log(this.PostosSelecionados.toString());
      this.data = [];
      var retrievedObject = localStorage.getItem('salaSituacao');
      if (retrievedObject != null) {
        var sala = JSON.parse(retrievedObject);
        this.relatorioService.getRelatorioPontoAtendimento(sala['postos'], this.PostosSelecionados.toString(), 3).pipe(
        ).subscribe((response: PostoPonto[]) => {
          console.log(response);
          if (response.length == 0)
            this.SemDados = true;
          else
            this.SemDados = false;
          this.data = response;
          this.data = this.data.sort((a, b) => {
            if (a.descricao < b.descricao) return -1;
            if (a.descricao > b.descricao) return 1;
            return 0;
          });
        });
      }
    }
    else {
      this.feitaPesquisa = true;
      this.data = [];
    }
  }

  filtrarPesquisa() {
    this.Pesquisa();
  }

  generateTableBody() {
    const body: any[] = [];

    // Cabeçalho da Tabela
    body.push([
      { text: 'Posto', style: 'header' },
      { text: 'Fila', style: 'header' },
      { text: 'Data Início / Hora', style: 'header' },
      { text: 'Data Fim / Hora', style: 'header' },
      { text: 'Tempo', style: 'header' },
      { text: 'Cidadão na Espera', style: 'header' },
      { text: 'Pontos Abertos', style: 'header' }
    ]);

    // Linhas de Dados

    return body;
  };

  exportarParaExcel(): void {
    const data: any[] = [];

    this.data.forEach(posto => {
      posto.pontosAtendimentos.forEach((ponto, pontoIndex) => {
        ponto.atendimentos.forEach((horario, horarioIndex) => {
          data.push({
            //Posto: horarioIndex === 0 && pontoIndex === 0 ? posto.descricao : '',
            //Ponto: horarioIndex === 0 ? ponto.descricao : '',
            'Posto': posto.descricao,
            'Ponto Atendimento	': ponto.descricao,
            'Data Início / Hora': this.formatDate(horario.abertura),
            'Data Fim / Hora	': this.formatDate(horario.fechamento),
            'Status do ponto': ponto.status
          });
        });
      });
    });

    const worksheet: XLSX.WorkSheet = {};
    const today = new Date();
    const formattedDate = `${today.getDate().toString().padStart(2, '0')}/${(today.getMonth() + 1).toString().padStart(2, '0')}/${today.getFullYear()}`;
    const formattedTime = `${today.getHours().toString().padStart(2, '0')}:${today.getMinutes().toString().padStart(2, '0')}`;
    const formattedDateTime = `${formattedDate} - ${formattedTime}`;
    XLSX.utils.sheet_add_aoa(worksheet, [['Relatório de Ponto de Atendimento - Emitido por: ' + this.login + " - " + formattedDateTime]], { origin: 'A1' });
    XLSX.utils.sheet_add_aoa(worksheet, [[]], { origin: 'A2' });
    XLSX.utils.sheet_add_json(worksheet, data, { origin: 'A3' });
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Relatório': worksheet },
      SheetNames: ['Relatório']
    };

    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const dataBlob: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    const formattedDate2 = today.toISOString().split('T')[0];
    FileSaver.saveAs(dataBlob, 'relatorio_ponto_atendimento-' + formattedDate2 + '.xlsx');
  }

  exportToPDF() {
    const body: any[] = [];

    body.push([
      { text: 'Posto', style: 'tableHeader' },
      { text: 'Ponto Atendimento', style: 'tableHeader' },
      { text: 'Data Início', style: 'tableHeader' },
      { text: 'Data Fim', style: 'tableHeader' },
      { text: 'Status', style: 'tableHeader' },
    ]);

    for (const item of this.data) {
      for (const ponto of item.pontosAtendimentos) {
        const atendimentos = ponto.atendimentos;

        for (let i = 0; i < atendimentos.length; i++) {
          const atendimento = atendimentos[i];

          const row: any[] = [];

          if (i === 0) {
            row.push({
              text: item.descricao,
              rowSpan: atendimentos.length
            });
          } else {
            row.push({});
          }

          if (i === 0) {
            row.push({
              text: ponto.descricao,
              rowSpan: atendimentos.length
            });
          } else {
            row.push({});
          }

          row.push({ text: this.formatDate(atendimento.abertura) });
          row.push({ text: this.formatDate(atendimento.fechamento) });

          if (i === 0) {
            row.push({
              text: ponto.status,
              rowSpan: atendimentos.length
            });
          } else {
            row.push({});
          }

          body.push(row);
        }
      }
    }
    const today = new Date();
    const formattedDate = `${today.getDate().toString().padStart(2, '0')}/${(today.getMonth() + 1).toString().padStart(2, '0')}/${today.getFullYear()}`;
    const formattedTime = `${today.getHours().toString().padStart(2, '0')}:${today.getMinutes().toString().padStart(2, '0')}`;
    const formattedDateTime = `${formattedDate} - ${formattedTime}`;
    const docDefinition: TDocumentDefinitions = {
      content: [
        {
          columns: [
            ...this.logosEsquerda,
            {
              width: "*", // Ocupa o espaço do meio
              text: "" // Espaço vazio entre os logos
            },
            {
              width: "auto", // Ajusta ao conteúdo dos logos
              alignment: "right",
              columnGap: 35, // Espaço fixo entre os logos
              columns:this.logosDireita
            }
          ]
        },
        {
          text: `Relatório: Ponto Atendimento`,
          style: 'header'
        },
        {
          columns: [

            {
              width: "auto", // Garante que o login não fique comprimido
              text: `Emitido por: ${this.login}` + ` - ` + `Data ${formattedDateTime}`,
              style: 'posto',
              fontSize: 8,
              margin: [0, 30, 0, 10],// Adiciona um espaçamento superior
              noWrap: true // Impede a quebra do texto
            },
          ]
        },
        {
          table: {
            headerRows: 1,
            widths: ['auto', '*', 'auto', 'auto', 'auto'],
            body: body,
          },
          layout: 'lightHorizontalLines'
        },
        {
          text: [
            { text: "Rua Agueda Gonçalves, 240 - Taboão da Serra - SP, 06760-900 - Tel:(11)28456000 (PABX)\n", fontSize: 8, alignment: 'center' },
            { text: "Correspondência: Caixa Postal 25901 - CEP: 05513-970 - SÃO PAULO-SP\n", fontSize: 8, alignment: 'center' },
            { text: "www.prodesp.sp.gov.br - prodesp@prodesp.sp.gov.br", fontSize: 8, alignment: 'center' }
          ],
          margin: [0, 10, 0, 0] // Remove espaçamento entre as linhas
        }
      ],
      styles: {
        header: {
          fontSize: 6,
          bold: true,
          alignment: 'center' as const // Alinhar texto centralizado
        },
        tableHeader: {
          bold: true,
          fillColor: '#eeeeee'
        }
      }
    };
    const formattedDate2 = today.toISOString().split('T')[0];
    pdfMake.createPdf(docDefinition).download('relatorio_ponto_atendimento-' + formattedDate2 + '.pdf');
  }

  formatDate(value: number | string): string {
    if (value == null || value == "") {
      return "";
    }
    const date = new Date(value);
    return date.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  getLetterFromNumber(num: number): string {
    const baseCharCode = 'A'.charCodeAt(0); // Código ASCII para 'A'
    return String.fromCharCode(baseCharCode + num - 1);
  }

  getTodayDate(): string {
    const date = new Date();
    const day = this.padZero(date.getDate());
    const month = this.padZero(date.getMonth() + 1);
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  padZero(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }

  ordenarPorColuna(campo: string): void {
    if (this.campoOrdenado === campo) {
      this.direcaoOrdenacao = this.direcaoOrdenacao === 'asc' ? 'desc' : 'asc';
    } else {
      this.campoOrdenado = campo;
      this.direcaoOrdenacao = 'asc';
    }
    console.log("Teste", this.data)
    this.data.sort((a, b) => {
      let valA: any;
      let valB: any;

      
  
      const pontoA = a?.pontosAtendimentos?.[0];
      const pontoB = b?.pontosAtendimentos?.[0];
  
      const atendimentoA = pontoA?.atendimentos?.[0];
      const atendimentoB = pontoB?.atendimentos?.[0];
  
      switch (campo) {
        case 'posto':
          valA = a?.descricao ?? '';
          valB = b?.descricao ?? '';
          break;
  
        case 'ponto':
          valA = pontoA?.descricao ?? '';
          valB = pontoB?.descricao ?? '';
          break;
  
        case 'status':
          valA = pontoA?.status ?? '';
          valB = pontoB?.status ?? '';
          break;
  
        case 'abertura':
          valA = atendimentoA?.abertura ? new Date(atendimentoA.abertura) : new Date(0);
          valB = atendimentoB?.abertura ? new Date(atendimentoB.abertura) : new Date(0);
          console.log("Teste::: ",valA);
          break;
  
        case 'fechamento':
          valA = atendimentoA?.fechamento ? new Date(atendimentoA.fechamento) : new Date(0);
          valB = atendimentoB?.fechamento ? new Date(atendimentoB.fechamento) : new Date(0);
          break;
  
        default:
          valA = '';
          valB = '';
      }
  
      // Se for string, comparar direto
      if (typeof valA === 'string' && typeof valB === 'string') {
        if (this.direcaoOrdenacao === 'asc') {
          return valA.localeCompare(valB);
        } else {
          return valB.localeCompare(valA);
        }
      }
  
      // Se for Date, comparar via getTime()
      if (valA instanceof Date && valB instanceof Date) {
        if (this.direcaoOrdenacao === 'asc') {
          return valA.getTime() - valB.getTime();
        } else {
          return valB.getTime() - valA.getTime();
        }
      }
  
      // Caso padrão numérico
      if (this.direcaoOrdenacao === 'asc') {
        return valA > valB ? 1 : valA < valB ? -1 : 0;
      } else {
        return valA < valB ? 1 : valA > valB ? -1 : 0;
      }
    });
  }
  
  
  
  private getTimestamp(value: string | number | undefined): number {
    if (value == null) return 0;
  
    if (typeof value === 'number') {
      return value; // já é timestamp
    }
  
    if (typeof value === 'string') {
      return this.parseCustomDate(value).getTime();
    }
  
    return 0;
  }
  
  private parseCustomDate(value: string): Date {
    if (!value) return new Date(0);
  
    const regex = /(\d{2})\/(\d{2})\/(\d{4}) - (\d{2}):(\d{2})h/;
    const match = value.match(regex);
  
    if (!match) return new Date(0);
  
    const day = parseInt(match[1], 10);
    const month = parseInt(match[2], 10) - 1;
    const year = parseInt(match[3], 10);
    const hour = parseInt(match[4], 10);
    const minute = parseInt(match[5], 10);
  
    return new Date(year, month, day, hour, minute);
  }
  
  
  
  
  
}